import imageCompression from 'browser-image-compression';

(function ($) {
	const Store = {
		get(el) {
			return window.W4D_FileStore.get(el);
		},
		add(el, list) {
			window.W4D_FileStore.add(el, list);
		},
		removeAt(el, index) {
			window.W4D_FileStore.removeAt(el, index);
		},
	};

	const origin = window.location.origin;

	const ICONS = {
		pdf: `${origin}/wp-content/themes/web-4d-theme/assets/img/pdf-document.svg`,
		doc: `${origin}/wp-content/themes/web-4d-theme/assets/img/word-document.svg`,
		docx: `${origin}/wp-content/themes/web-4d-theme/assets/img/word-document.svg`,
	};

	class W4D_FileUpload {
		constructor() {
			this.galleries = new Map(); // lightGallery instances per input id
			this.init();
		}

		// ---------- Type & helpers ----------
		isImage(file) {
			if (file && typeof file.type === 'string' && file.type) return file.type.startsWith('image/');
			const name = (file?.name || '').toLowerCase();
			return /\.(png|jpe?g|webp|gif|bmp|tiff|svg)$/.test(name);
		}

		getStaticIconFor(file) {
			const name = (file?.name || '').toLowerCase();
			const extMatch = name.match(/\.([a-z0-9]+)$/i);
			const ext = extMatch ? extMatch[1] : '';
			if (ext === 'pdf') return ICONS.pdf;
			if (ext === 'doc' || ext === 'docx') return ICONS.doc;
			return null;
		}

		makeSignature(file) {
			// Signature is based on original chosen file: name
			return `${file.name}`;
		}

		getExistingSignatures(input) {
			const $list = $(input).closest('[data-js-file-upload]').find('.file-upload__list');
			const sigs = new Set();
			$list.find('.file-upload__item').each((_, li) => {
				const sig = li.getAttribute('data-orig-sig');
				if (sig) sigs.add(sig);
			});
			return sigs;
		}

		_getNoticeRoot(input) {
			return $(input).closest('[data-js-file-upload]').find('.w4d-notice-inline').first();
		}

		clearNotices(input) {
			const $notice = this._getNoticeRoot(input);
			if (!$notice.length) return;
			$notice.find('.w4d-notice-inline__list').empty();
			$notice.addClass('hidden').attr('aria-hidden', 'true');
		}

		addNotices(input, messages) {
			if (!Array.isArray(messages) || messages.length === 0) return;
			const $notice = this._getNoticeRoot(input);
			if (!$notice.length) return;
			const $list = $notice.find('.w4d-notice-inline__list');
			if (!$list.length) return;
			const frag = document.createDocumentFragment();
			messages.forEach((msg) => {
				const li = document.createElement('li');
				li.textContent = msg;
				frag.appendChild(li);
			});
			$list[0].appendChild(frag);
			$notice.removeClass('hidden').removeAttr('aria-hidden');
		}

		// ---------- Processing ----------
		async compressFile(file) {
			if (!this.isImage(file)) return file;
			const options = {
				maxSizeMB: 2,
				useWebWorker: true,
				fileType: 'image/jpeg',
				maxWidthOrHeight: 1920,
				initialQuality: 0.75,
			};
			try {
				const compressedBlob = await imageCompression(file, options);
				return new File([compressedBlob], file.name.replace(/\.[^/.]+$/, '.jpg'), { type: 'image/jpeg' });
			} catch {
				return file;
			}
		}

		async createImagePreview(file) {
			return new Promise((resolve) => {
				const reader = new FileReader();
				reader.onload = (e) => resolve(e.target.result);
				reader.onerror = () => resolve(null);
				reader.readAsDataURL(file);
			});
		}

		// ---------- Formatters ----------
		formatFileSize(bytes) {
			if (bytes < 1048576) return Math.round(bytes / 1024) + ' kB';
			return (bytes / 1048576).toFixed(2) + ' MB';
		}

		splitFileName(fileName) {
			const lastDotIndex = fileName.lastIndexOf('.');
			if (lastDotIndex === -1) return { baseName: fileName, extension: '' };
			return {
				baseName: fileName.substring(0, lastDotIndex),
				extension: fileName.substring(lastDotIndex),
			};
		}

		// ---------- Progress ----------
		getTotalSize(input) {
			const files = Store.get(input);
			return files.reduce((sum, file) => sum + file.size, 0);
		}

		getMaxTotalSize(input) {
			const maxSizeStr = $(input).attr('data-rule-maxsizetotal') || '24MB';
			const matches = maxSizeStr.match(/^(\d+(?:\.\d+)?)(MB|KB)$/i);
			if (!matches) return 24 * 1024 * 1024;
			const value = parseFloat(matches[1]);
			const unit = matches[2].toUpperCase();
			return unit === 'MB' ? value * 1024 * 1024 : value * 1024;
		}

		updateProgress(input) {
			const $root = $(input).closest('[data-js-file-upload]');
			const files = Store.get(input);
			const totalSize = this.getTotalSize(input);
			const maxSize = this.getMaxTotalSize(input);
			const percentage = Math.min((totalSize / maxSize) * 100, 100);

			// Update count
			$root.find('[data-js-total-count]').text(files.length);

			// Update total size
			const $progressNow = $root.find('[data-js-progress-now]');

			// Update max total size
			$root.find('[data-js-total-size]').text(this.formatFileSize(totalSize));

			// Update progress bar
			const $progressInner = $progressNow.closest('.file-upload__progress').find('.progress__inner');
			$progressInner.css('--progress', `${percentage.toFixed(2)}%`);
		}

		// ---------- Init / Bind ----------
		init() {
			this.$roots = $('[data-js-file-upload]');
			if (!this.$roots.length) return;

			this.$roots.find('.file-upload__input').each(function () {
				if (!this.id) this.id = 'w4d-file-' + Math.random().toString(36).slice(2, 10);
			});

			this.bindEvents();
			this.initialRender();
		}

		bindEvents() {
			// Add files (with duplicate prevention)
			this.$roots.on('change', '.file-upload__input', (e) => this.handleFileChange(e));

			// Remove file (compute index live)
			this.$roots.on('click', '[data-js-remove-file]', async (e) => {
				e.preventDefault();
				const $item = $(e.currentTarget).closest('.file-upload__item');
				const $list = $item.closest('.file-upload__list');
				const input = $list.closest('[data-js-file-upload]').find('.file-upload__input')[0];
				if (!input) return;

				const $finalItems = $list.find('.file-upload__item:not(.file-upload__loading)');
				const index = $finalItems.index($item);
				if (index < 0) return;

				Store.removeAt(input, index);
				$item.remove();

				this.updateProgress(input);
				await this.updateGallery(input);
				$(input).valid();
			});

			// Open lightGallery on image preview click at the correct image-only index
			this.$roots.on('click', '.file-upload__preview, .file-upload__preview img', (e) => {
				const $item = $(e.currentTarget).closest('.file-upload__item');
				const $list = $item.closest('.file-upload__list');
				const $input = $list.closest('[data-js-file-upload]').find('.file-upload__input');
				const inputId = $input[0]?.id;
				if (!inputId || !this.galleries.has(inputId)) return;

				const idxAttr = $item.attr('data-image-index');
				if (idxAttr === undefined) return;

				const slideIndex = parseInt(idxAttr, 10);
				if (Number.isNaN(slideIndex)) return;

				this.galleries.get(inputId).openGallery(slideIndex);
			});
		}

		// ---------- Change handler with duplicate prevention ----------
		async handleFileChange(e) {
			const input = e.currentTarget;
			if (!input.files || input.files.length === 0) return;

			const selected = Array.from(input.files);

			// Gather previously seen signatures from DOM
			const existingSigs = this.getExistingSignatures(input);
			const batchSeen = new Set();

			const keptFiles = [];
			const keptSigs = [];
			const duplicateMessages = [];

			for (const f of selected) {
				const sig = this.makeSignature(f);
				if (existingSigs.has(sig) || batchSeen.has(sig)) {
					duplicateMessages.push(`- ${f.name}`);
					continue;
				}
				batchSeen.add(sig);
				keptFiles.push(f);
				keptSigs.push(sig);
			}

			// Render duplicate notices (if any)
			if (duplicateMessages.length > 0) {
				this.addNotices(input, duplicateMessages);
			}

			if (keptFiles.length === 0) {
				input.value = '';
				return;
			}

			const fileIds = keptFiles.map((_, i) => `file-${Date.now()}-${i}`);

			// Optional: clear previous notices when adding valid files
			this.clearNotices(input);

			this.renderFileItems(keptFiles, keptSigs, input, fileIds);
			this._setRemoveButtonsDisabled(input, true);

			const processedFiles = await Promise.all(
				keptFiles.map(async (file, i) => {
					let processed = file;
					let previewUrl = null;

					if (this.isImage(file)) {
						processed = await this.compressFile(file);
						previewUrl = await this.createImagePreview(processed);
					} else {
						previewUrl = this.getStaticIconFor(file);
					}

					this.updateFileItemWithPreview(fileIds[i], previewUrl, processed.name, processed.size);
					return processed;
				})
			);

			Store.add(input, processedFiles);

			this._setRemoveButtonsDisabled(input, false);
			this.updateProgress(input);
			await this.updateGallery(input);
			input.value = '';
			$(input).valid();
		}

		// ---------- Rendering ----------
		renderFileItems(files, sigs, input, fileIds) {
			const $list = $(input).closest('[data-js-file-upload]').find('.file-upload__list');
			files.forEach((file, i) => {
				const $item = this.createFileListItem({
					fileId: fileIds[i],
					fileName: file.name,
					fileSize: file.size,
					isLoading: true,
				});
				// Store original signature on item for future duplicate detection
				$item.attr('data-orig-sig', sigs[i]);
				$list.append($item);
			});
		}

		updateFileItemWithPreview(fileId, previewUrl, fileName, fileSize) {
			const $item = $(`[data-file-id="${fileId}"]`);
			if (!$item.length) return;

			$item.removeClass('file-upload__loading');

			const $preview = $item.find('.file-upload__preview');
			$preview.html(previewUrl ? `<img src="${previewUrl}" alt="${this.escape(fileName)}" class="file-upload__thumbnail">` : '');

			const { baseName, extension } = this.splitFileName(fileName);
			$item.find('.file-upload__name').text(baseName);
			$item.find('.file-upload__ext').text(extension);
			$item.find('.file-upload__item-size span').text(this.formatFileSize(fileSize));
			$item.find('.file-remove').prop('disabled', false);
		}

		initialRender() {
			const self = this;
			this.$roots.find('.file-upload__input').each(async function () {
				const files = Store.get(this);
				if (files.length > 0) {
					await self.renderFor(this);
					self.updateProgress(this);
					await self.updateGallery(this);
				}
			});
		}

		async renderFor(input) {
			const $root = $(input).closest('[data-js-file-upload]');
			const $list = $root.find('.file-upload__list');
			const files = Store.get(input);
			$list.empty();

			for (let i = 0; i < files.length; i++) {
				const file = files[i];
				const previewUrl = this.isImage(file) ? await this.createImagePreview(file) : this.getStaticIconFor(file);
				const fileId = `file-existing-${i}`;
				const $item = this.createFileListItem({
					fileId,
					fileName: file.name,
					fileSize: file.size,
					isLoading: false,
					previewUrl,
				});
				// We don't have original signatures post-reload; tag with current file’s name+size to keep behavior consistent within session.
				$item.attr('data-orig-sig', this.makeSignature(file));
				$list.append($item);
			}
		}

		createFileListItem({ fileId, fileName, fileSize, isLoading = false, previewUrl = null }) {
			const $template = $('#file-upload-item-template');
			const $item = $($template[0].content).find('.file-upload__item').clone();

			const formattedSize = this.formatFileSize(fileSize);
			const { baseName, extension } = this.splitFileName(fileName);

			$item.attr('data-file-id', fileId);

			if (isLoading) {
				$item.addClass('file-upload__loading');
				$item.find('.file-upload__preview').html('<span class="loader show"></span>');
				$item.find('.file-remove').attr('disabled', true);
			} else if (previewUrl) {
				const $img = $('<img>', {
					src: previewUrl,
					alt: this.escape(fileName),
					class: 'file-upload__thumbnail',
				});
				$item.find('.file-upload__preview').append($img);
			}

			// Postavljanje naziva i veličine
			$item.find('.file-upload__name').text(this.escape(baseName));
			$item.find('.file-upload__ext').text(this.escape(extension));
			$item.find('.file-upload__item-size span').text(formattedSize);

			// Postavljanje aria-labela na gumb
			$item.find('.file-remove').attr('aria-label', `Ukloni datoteku ${this.escape(fileName)}`);

			return $item;
		}

		// ---------- lightGallery dynamic (refresh) ----------
		async updateGallery(input) {
			const $root = $(input).closest('[data-js-file-upload]');
			const $list = $root.find('.file-upload__list');
			const inputId = input.id;
			const files = Store.get(input) || [];

			const dynamicEl = [];
			for (const f of files) {
				if (!this.isImage(f)) continue;
				const src = await this.createImagePreview(f);
				dynamicEl.push({
					src,
					thumb: src,
					subHtml: `<h4>${this.escape(f.name)}</h4>`,
				});
			}

			if (dynamicEl.length === 0) {
				if (this.galleries.has(inputId)) {
					this.galleries.get(inputId).destroy();
					this.galleries.delete(inputId);
				}
				this._tagImageIndexes($list);
				return;
			}

			if (!this.galleries.has(inputId)) {
				const galleryInstance = lightGallery($list[0], {
					dynamic: true,
					dynamicEl,
					speed: 500,
					download: false,
				});
				this.galleries.set(inputId, galleryInstance);
			} else {
				this.galleries.get(inputId).refresh(dynamicEl);
			}

			this._tagImageIndexes($list);
		}

		_tagImageIndexes($list) {
			let imgIndex = 0;
			$list.find('.file-upload__item').each((_, li) => {
				const $li = $(li);
				const extText = ($li.find('.file-upload__ext').text() || '').toLowerCase();
				const isImgExt = !!extText && /\.(png|jpe?g|webp|gif|bmp|tiff|svg)$/.test(extText);
				if (isImgExt) {
					$li.attr('data-image-index', String(imgIndex));
					imgIndex += 1;
				} else {
					$li.removeAttr('data-image-index');
				}
			});
		}

		// ---------- Utils ----------
		escape(str) {
			return String(str)
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/"/g, '&quot;')
				.replace(/'/g, '&#039;');
		}

		_setRemoveButtonsDisabled(input, disabled) {
			const $root = $(input).closest('[data-js-file-upload]');
			$root.find('.file-remove').prop('disabled', disabled);
		}
	}

	$(function () {
		new W4D_FileUpload();
	});
})(jQuery);
